import api from '@/api'
import { firebaseApp, firebaseFunctions } from '@/firebase'
const store = {
  state: {
    dataMenuItemLimit: [],
    pagingMenuItemLimit: {
      page: 1,
      size: 20,
      total: 0
    },
    sortingMenuItemLimit: {
      byField: '',
      isDesc: false
    },
    filteringMenuItemLimit: {
      f_outletCode: '',
      menuItemCode: null,
      orderType: null
    }
  },

  mutations: {
    SET_MENUITEMLIMIT: (state, payload) => {
      state.dataMenuItemLimit = payload
    },
    SET_PAGING_PAGE_MENUITEMLIMIT: (state, payload) => {
      state.pagingMenuItemLimit.page = payload
    },
    SET_PAGING_TOTAL_MENUITEMLIMIT: (state, payload) => {
      state.pagingMenuItemLimit.total = payload
    },
    SET_SORTING_MENUITEMLIMIT: (state, payload) => {
      state.sortingMenuItemLimit = payload
    },
    SET_FILTERING_MENUITEMLIMIT: (state, payload) => {
      state.filteringMenuItemLimit = payload
    }
  },

  getters: {
    SortingMenuItemLimit: state => state.sortingMenuItemLimit,
    FilteringMenuItemLimit: state => state.filteringMenuItemLimit,
    PagingMenuItemLimit: state => state.pagingMenuItemLimit,
    GetAllMenuItemLimit: state => state.dataMenuItemLimit,
    GetOneMenuItemLimit: state => id =>
      state.dataMenuItemLimit.find(
        dataMenuItemLimit => dataMenuItemLimit.id === id
      )
  },

  actions: {
    async UpdateSortingMenuItemLimit({ commit, dispatch }, payload) {
      commit('SET_SORTING_MENUITEMLIMIT', {
        byField: payload.byField,
        isDesc: payload.isDesc
      })
      dispatch('GetAllLimitForNewInterface')
    },

    async UpdateFilteringMenuItemLimit({ commit, dispatch }, isResetField) {
      if (isResetField) {
        const emptyFilter = {
          cond: null,
          code: null,
          description: null
        }
        commit('SET_FILTERING_MENUITEMLIMIT', emptyFilter)
      }
      commit('SET_PAGING_PAGE_MENUITEMLIMIT', 1)
      dispatch('GetAllLimitForNewInterface')
    },

    async GetAllMenuItemLimit({ commit, state }) {
      try {
        commit('SET_IS_FETCHING_DATA', true)
        const result = await api.GetAllMenuItemLimit(
          state.pagingMenuItemLimit,
          state.sortingMenuItemLimit,
          state.filteringMenuItemLimit
        )
        commit('SET_IS_FETCHING_DATA', false)
        commit('SET_PAGING_TOTAL_MENUITEMLIMIT', result.headers['data-length'])
        commit('SET_MENUITEMLIMIT', result.data.data)
        return result.data
      } catch (e) {
        commit('SET_IS_FETCHING_DATA', false)
        throw e
      }
    },

    async CreateMenuItemLimit({ dispatch }, payload) {
      try {
        const { data } = await api.CreateMenuItemLimit(payload)
        dispatch('GetAllMenuItemLimit')
        return data
      } catch (e) {
        return e.response
      }
    },

    async UpdateMenuItemLimit({ dispatch }, payload) {
      try {
        const { data } = await api.UpdateMenuItemLimit(payload.id, payload)
        dispatch('GetAllMenuItemLimit')
        return data
      } catch (e) {
        return e.response
      }
    },

    async DeleteMenuItemLimit({ dispatch }, id) {
      try {
        const { data } = await api.DeleteMenuItemLimit(id)
        dispatch('GetAllMenuItemLimit')
        return data
      } catch (e) {
        throw e
      }
    },

    async CreateLimitForNewInterface({ dispatch }, payload) {
      try {
        const { data } = await api.CreateLimitForNewInterface(payload)
        dispatch('GetAllLimitForNewInterface')
        return data
      } catch (e) {
        return e.response
      }
    },

    async UpdateLimitForNewInterface({ dispatch }, payload) {
      try {
        const { data } = await api.UpdateLimitForNewInterface(payload)
        dispatch('GetAllLimitForNewInterface')
        return data
      } catch (e) {
        return e.response
      }
    },

    async GetAllLimitForNewInterface({ commit, state }) {
      try {
        commit('SET_IS_FETCHING_DATA', true)
        const { data } = await firebaseFunctions.httpsCallable(
          'refreshAuthUser'
        )({
          loginId: firebaseApp.auth().currentUser!.uid
        })
        if (data.data.Type !== 'Admin') {
          const splitOutletCodes = data.data.OutletCodes
          commit('SET_FILTERING_MENUITEMLIMIT', {
            ...state.filteringMenuItemLimit,
            f_outletCode: splitOutletCodes.join(',')
          })
        } else {
          commit('SET_FILTERING_MENUITEMLIMIT', {
            ...state.filteringMenuItemLimit,
            f_outletCode: ''
          })
        }
        const result = await api.GetAllLimitForNewInterface(
          state.pagingMenuItemLimit,
          state.sortingMenuItemLimit,
          state.filteringMenuItemLimit
        )
        commit('SET_IS_FETCHING_DATA', false)
        commit('SET_PAGING_TOTAL_MENUITEMLIMIT', result.data.result.count)
        commit('SET_MENUITEMLIMIT', result.data.result.data)
        return result.data
      } catch (e) {
        commit('SET_IS_FETCHING_DATA', false)
        throw e
      }
    },

    async DeleteLimitForNewInterface({ dispatch }, payload) {
      try {
        const { data } = await api.DeleteLimitForNewInterface(payload)
        dispatch('GetAllLimitForNewInterface')
        return data
      } catch (e) {
        throw e
      }
    }
  }
}

export default store
